import { render, staticRenderFns } from "./adlist.vue?vue&type=template&id=606dc9a4&scoped=true"
import script from "./adlist.vue?vue&type=script&lang=js"
export * from "./adlist.vue?vue&type=script&lang=js"
import style0 from "./adlist.vue?vue&type=style&index=0&id=606dc9a4&prod&lang=css"
import style1 from "./adlist.vue?vue&type=style&index=1&id=606dc9a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606dc9a4",
  null
  
)

export default component.exports